
import PySerpQuery from './components/query/index.js';
import PySerpRequest from './components/request/index.js';
import SerpState, { SerpStateElements } from './components/state/index.js';

class PySerp {
    constructor(config, selectStateElement) {
        // eslint-disable-next-line no-console
        console.info('search config:', config);

        this.config = config;
        this.setComponents(selectStateElement);
    }

    setComponents(selectStateElement) {
        //this.serpView = new PySerpView();
        this.serpQuery = new PySerpQuery(this.config);
        this.serpRequest = new PySerpRequest();
        this.serpState = new SerpState(document.querySelector(selectStateElement), this.config, SerpStateElements);
    }

    load() {
        this.serpState.loading();

        if(this.config.errorCode) {
            this.serpState.error();
            return Promise.reject();
        }

        this.serpRequest.execute(this.serpQuery);

        return this.serpRequest.promise
            .then(details => {
                // eslint-disable-next-line no-console
                console.info('results:', details);
                this.serpState.ready();
                return Promise.resolve(details);
            })
            .catch(details => {
                //Troublesome error handling
                // eslint-disable-next-line no-console
                console.info('error:', details);
                this.serpState.error(details);
                return Promise.reject(details);
            });
    }
}




export default PySerp;